import { useTranslation } from 'react-i18next';

import { VFlex, VStack } from '@/package';
import type { User } from '@/type';

const UserListTooltip = ({
  managerList,
  workerList,
}: {
  managerList: User[];
  workerList: User[];
}) => {
  const { t } = useTranslation();
  const managerNum = managerList.length;
  const workerNum = workerList.length;

  return (
    <VStack>
      {!!managerNum && (
        <VFlex gap={0.125}>
          <span>•</span>
          {t('role.manager.nonresidenter').toLowerCase()} :{' '}
          {managerList.map(manager => manager.name || manager.email).join(', ')}
        </VFlex>
      )}
      {!!workerNum && (
        <VFlex gap={0.125}>
          <span>•</span>
          {t('role.labeler.updelve').toLowerCase()} :{' '}
          {workerList.map(worker => worker.name || worker.email).join(', ')}
        </VFlex>
      )}
    </VStack>
  );
};

export default UserListTooltip;
